/*
 * @Description: 其他原生api
 */

import xbb from '@xbb/xbb-utils'
import { ElMessage } from 'element-plus'
import utils from '..'
// import AppMessage from '@/components/message/index.js'

/**
 * 判断手机权限
 * @param {any} permission  权限判断
 */
const iosPermissionPos = (permission, content, onSuccess, onFail) => {
  const pp = window.plus && window.plus.navigator.checkPermission(permission)
  // authorized=开启 denied=关闭 undetermined=未确定 unknown=无法查询
  if (pp === 'authorized' || pp === 'undetermined' || pp === 'unknown') {
    const type = pp === 'authorized' ? 1 : 0
    if (!type) {
      ElMessage.info(content)
    }
    onSuccess(type)
  } else {
    ElMessage.error(content)
    onFail()
  }
}

/**
 * 请求安卓手机权限
 * @param {array} name  请求权限 相机，联系人，相册，定位，录音
 *['android.permission.CAMERA', 'android.permission.READ_CONTACTS', 'android.permission.READ_EXTERNAL_STORAGE',
 *'android.permission.ACCESS_COARSE_LOCATION', 'android.permission.RECORD_AUDIO']
 */
const androidPermissionPos = (permission, content, onSuccess, onFail) => {
  // 先弹一次，如果用户同意了，记录状态，以后不再弹窗
  const isAuthorized = utils.xbbLocalStorageGet(permission[0])
  let message
  if (!isAuthorized) {
    message = ElMessage.info(content)
  }
  window.plus.android.requestPermissions(
    permission,
    function (e) {
      message && message.close()
      if (e.deniedAlways.length > 0) {
        // 权限被永久拒绝
        ElMessage.error(content)
      } else if (e.deniedPresent.length > 0) {
        // 权限被临时拒绝
        ElMessage.error(content)
      } else if (e.granted.length > 0) {
        // 权限被允许
        onSuccess(1)
        utils.xbbLocalStorageSet(permission[0], 1)
      } else {
        alert('权限有问题' + JSON.stringify(e) + name)
      }
    },
    function (e) {
      ElMessage.error('权限' + name + '开启失败')
      onFail()
    }
  )
}

// function requestPermission(permissionMap, type) {
//   const Build = window.plus.android.importClass('android.os.Build')
//   if (Build.VERSION.SDK_INT < 33) return
//   if (type === 2) {
//     permissionMap[2].android = [
//       'android.permission.READ_MEDIA_IMAGES',
//       'android.permission.READ_MEDIA_VIDEO'
//     ]
//   }
// }

// type 0=摄像头，1=联系人，2=相册，3=定位，4=录音
const h5ChoosePermission = ({ type, onSuccess = (_) => {}, onFail = (_) => {} }) => {
  const permissionMap = {
    0: {
      ios: 'CAMERA',
      android: ['android.permission.CAMERA'],
      content: '用于扫码(条形码、二维码)、扫名片、拍照、签到等功能'
    },
    1: {
      ios: 'CONTACTS',
      android: ['android.permission.READ_CONTACTS'],
      content: '用于快捷录入客户信息服务'
    },
    2: {
      ios: 'GALLERY',
      android: ['android.permission.READ_EXTERNAL_STORAGE'],
      content: '用于上传您的照片、图片、视频等内容'
    },
    3: {
      ios: 'LOCATION',
      android: ['android.permission.ACCESS_COARSE_LOCATION'],
      content: '用于展示所需地点在地图中的定位、签到以及在表单中录入定位字段'
    },
    4: {
      ios: 'RECORD',
      android: ['android.permission.RECORD_AUDIO'],
      content: '用于上传通话录音'
    },
    5: {
      ios: 'NOTIFITION',
      android: ['android.permission.POST_NOTIFICATIONS'],
      content: '用于消息推送'
    },
    6: {
      ios: '',
      android: ['android.permission.CALL_PHONE'],
      content: '用于拨出电话'
    },
    7: {
      ios: '',
      android: ['android.permission.WRITE_EXTERNAL_STORAGE'],
      content: '用于图片保存'
    },
    8: {
      ios: 'GALLERY',
      android: ['android.permission.READ_EXTERNAL_STORAGE'],
      content: '用于上传您的文档、附件等内容'
    },
    9: {
      ios: '',
      android: ['android.permission.READ_PHONE_STATE'],
      content: '用于来电时暂停录音'
    },
    10: {
      ios: '',
      android: ['android.permission.FOREGROUND_SERVICE'],
      content: '用于熄屏录音'
    }
  }
  const system = xbb.browser()

  // 处理高版本安卓的兼容性问题
  // if (system === 'Android') {
  //   requestPermission(permissionMap, type)
  // }

  const { ios, android, content } = permissionMap[type]
  if (system === 'ios' && ios.length) {
    iosPermissionPos(ios, content, onSuccess, onFail)
  } else if (system === 'Android' && android.length) {
    androidPermissionPos(android, content, onSuccess, onFail)
  } else {
    onSuccess()
  }
}

/**
 * 删除本地文件
 * @param {*} path
 * @param {*} onSuccess
 */
const h5DelFile = ({ path, onSuccess = (_) => {}, onFail = (_) => {} }) => {
  window.plus.io.resolveLocalFileSystemURL(path, function (entry) {
    entry.remove(
      function (entry) {
        onSuccess()
      },
      function (e) {
        onFail()
      }
    )
  })
}

// 获取指定APPID对应的应用信息
const h5GetProperty = (callBack) => {
  window.plus.runtime.getProperty(window.plus.runtime.appid, callBack)
}

// 手机浏览器打开第三方链接
const xbbOpenLink = ({ url }) => {
  window.plus.runtime.openURL(
    url,
    (_) => {
      console.log('success')
    },
    (_) => {
      window.plus.nativeUI.alert('打开失败')
    }
  )
}

/**
 * 下载文件
 * @param {any} url
 * @param {any} onSuccess
 * @param {any} onFail
 * @param {any} onProgress 进度回调
 */
const h5DownLoadFile = ({
  url,
  options = {},
  onSuccess = (_) => {},
  onFail = (_) => {},
  onProgress = (_p) => {}
}) => {
  const dtask = window.plus.downloader.createDownload(url, options, function (d, status) {
    // 下载完成
    if (status === 200) {
      onSuccess(d.filename)
    } else {
      onFail()
    }
  })
  dtask.addEventListener('statechanged', function (task) {
    if (task.state === 3) {
      // 下载中
      const percent =
        task.totalSize > 0 ? Math.floor((task.downloadedSize / task.totalSize) * 100) : 0
      onProgress(percent)
    }
  })
  dtask.start()
}

// 安装应用
const h5InstallApp = ({ name, onSuccess = (_) => {}, onFail = (_) => {} }) => {
  window.plus.runtime.install(name, {}, onSuccess, onFail)
}

// 拨打电话
const xbbDial = ({ phoneNumber, refId, refType, onSuccess }) => {
  console.log(phoneNumber, refId, refType, '打电话入参')
  h5ChoosePermission({
    type: 6,
    onSuccess: () => {
      // 判断是否从呼叫中心打电话
      if (refId && refType && xbb.browser() === 'Android') {
        try {
          // 引入第三方jar包
          const NjsTest = window.plus.android.importClass(
            'com.pactera.xbcrm.recorder.bridge.JsInterface'
          )
          const activity = window.plus.android.runtimeMainActivity()
          const jsInterface = new NjsTest(activity)
          const flag = utils.xbbLocalStorageGet('getAutoUploadStatus') === '1' // 缓存是字符串类型
          const userId = utils.xbbLocalStorageGet('userId')
          const corpId = utils.xbbLocalStorageGet('corpid')
          const token = utils.xbbLocalStorageGet('xbbAccessToken')
          // 是否允许 4G 网络自动上传 flag：true：开启;false：未开启
          jsInterface.enableCellarNetworkUpload(flag)
          // 保存用户凭证 userId：用户id;corpId:公司id
          jsInterface.setUserCredential(userId, corpId, token)
          // 传入拨打电话的相关信息 refType：数据id;refId：业务类型;phoneNumber：手机号
          jsInterface.startCall(corpId, userId, parseInt(refType), parseInt(refId), phoneNumber)
        } catch (e) {
          console.log(e)
        }
      } else {
        window.plus.device.dial(phoneNumber, true)
      }
      onSuccess && onSuccess()
    }
  })
}

export default {
  h5DelFile,

  h5ChoosePermission,
  h5GetProperty,
  xbbOpenLink,
  h5DownLoadFile,
  h5InstallApp,
  xbbDial
}
